export default "__VITE_ASSET__7498fc80__"